// extracted by mini-css-extract-plugin
module.exports = {"DetailsList":"DetailsList_DetailsList__2hmmx","footer":"DetailsList_footer__Z4L5l","header":"DetailsList_header__2y_Em"};